import Api from '../api';
import QueryString from 'query-string';
import { isEmpty as _isEmpty, omitBy as _omitBy } from 'lodash-es';

export default class WorkSpaceApi extends Api {
  getDeepDiveData = async props => {
    const queryParams = { ...props };
    const queryObj = _omitBy(queryParams, _isEmpty);
    const queryString = QueryString.stringify(queryObj);
    try {
      const { data } = await this.get(`chart/motherDashboard?${queryString}`);
      return { data };
    } catch (error) {
      return {
        hasError: true,
        error: error.response
      };
    }
  };

  getWorkspaceDashboardDetails = async props => {
    const { id, trace_id, path } = props;
    try {
      const apiData = await this.get(
        `/custom-dashboard/?dashboardId=${id}&type=order_status&trace_id=${trace_id}&path=${path}`
      );
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: 'Fail to get dashboard details'
      };
    }
  };

  onCreateECommerceDashboard = async payload => {
    const { trace_id, path, otherDashboards } = payload;
    try {
      const apiData = await this.post(`/custom-dashboard/?trace_id=${trace_id}&path=${path}`, otherDashboards);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: 'Fail to create dashboard'
      };
    }
  };

  // // not using anywhere
  // onUpdateWorkSpaceDashboard = async (props, dashboard_id) => {
  //   const { trace_id, path, ...payload } = props;
  //   try {
  //     const apiData = await this.patch(`/custom-dashboard/${dashboard_id}?trace_id=${trace_id}&path=${path}`, payload);
  //     return apiData;
  //   } catch (error) {
  //     return {
  //       hasError: true,
  //       error: error,
  //       customMessage: 'Fail to update dashboard.'
  //     };
  //   }
  // };
  onUpdateWDefaultDashboard = async (payload, dashboard_id) => {
    const { trace_id, path, ...rest } = payload;
    try {
      const apiData = await this.put(`/custom-dashboard/${dashboard_id}?trace_id=${trace_id}&path=${path}`, rest);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: 'Fail to update dashboard.'
      };
    }
  };
}
